/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_Image_Too_LargeInputs */



/**
* | output |
* | --- |
* | "This image's resolution is too high to index." |
*
* @param {Embedding_Error_Image_Too_LargeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_image_too_large = /** @type {((inputs?: Embedding_Error_Image_Too_LargeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_Image_Too_LargeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Auflösung dieses Bildes ist zu hoch, um es zu indexieren.")
	return /** @type {LocalizedString} */ ("This image's resolution is too high to index.")
});